module.exports = __webpack_public_path__ + "img/asymmetry.d4efd64b.svg";